module.exports = __webpack_public_path__ + "static/media/apartment12.56aee3a1.jpg";